import { GoogleMap, useJsApiLoader, Polyline, OverlayView } from '@react-google-maps/api';
import { googleMapsColorConfig } from 'config/google-maps-color-config';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import Spinner from 'components/Spinner/Spinner';
import ZonesStore from 'stores/Zones';
import styles from './Map.module.scss';

const PATH_OPTIONS = {
  strokeColor: '#FF0000',
  strokeOpacity: 1,
  strokeWeight: 5,
  fillColor: '#FF0000',
  fillOpacity: 1,
  clickable: false,
  draggable: false,
  editable: false,
  visible: true,
  zIndex: 1
};

const containerStyle = {
  width: '100%',
  height: '100%'
};

const Map = observer(({tracks, center, zoom = 16}) => {

  const navigate = useNavigate();

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyBXhsUiHN0qMXoQ8IIBhD94Gsy7O0yKjzs'
  });

  function getPath() {
    return tracks?.map(({latitude, longitude}) => {
      return {
        lat: latitude,
        lng: longitude
      }
    })
  }

  function onMarkerClick(zone) {
    navigate(`/parking/${zone.id}`);
  }

  function getPixelPositionOffset(width, height) {
    return {
      x: width / -2,
      y: height * -1
    }
  }

  if (!isLoaded || !center) {
    return (
      <div className={styles.spinner}>
        <Spinner />
      </div>
    )
  }

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={zoom}
      options={{
        disableDefaultUI: true,
        styles: googleMapsColorConfig,
        backgroundColor: 'none'
      }}
    >
      <Polyline
        path={getPath()}
        options={PATH_OPTIONS}
      />

      {ZonesStore.list?.map(id => {
        const zone = ZonesStore.find(parseInt(id));
        return (
          <OverlayView
            key={id + (new Date()).getTime().toString()}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            position={zone.coordinates?.[0]}
            getPixelPositionOffset={getPixelPositionOffset}
          >
            <div className={styles.marker} onClick={event => onMarkerClick(zone)}>
              <div className={styles.markerIcon}></div>
              <div className={styles.bar}></div>
              {zone.scootersCount !== null &&
                <div className={styles.counter}>
                  {zone.scootersCount}
                </div>
              }
            </div>
          </OverlayView>
        );
      })}
    </GoogleMap>
  );

});

export default Map;